import { TestimonialCard } from './TestimonialCard';
import { FormattedMessage } from 'react-intl';

const testimonials = [
  {
    name: "Анна К.",
    role: "Клиент",
    text: "Нашла отличного репетитора по английскому для детей. Очень удобный сервис!",
    rating: 5
  },
  {
    name: "Михаил В.",
    role: "Мастер по ремонту",
    text: "Благодаря платформе регулярно получаю новые заказы. Отличная возможность для развития бизнеса.",
    rating: 5
  },
  {
    name: "Елена П.",
    role: "Клиент",
    text: "Быстро нашла парикмахера рядом с домом. Очень довольна результатом!",
    rating: 5
  }
];

export function Testimonials() {
  return (
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12">
            <FormattedMessage id="testimonials.title" defaultMessage="Отзывы пользователей" />
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
                <TestimonialCard key={index} {...testimonial} />
            ))}
          </div>
        </div>
      </section>
  );
}
